export default __webpack_public_path__ + "static/media/timeline-vertical.3833cfaa.png";